type ShowModal = (modalType: string, modalProps?: any) => void;

export const noFeatureAccessModalProps = {
    title: 'Unfortunately, you do not have access to this feature.',
    description: 'Please contact your business administrator for more information.',
    question: '',
};

export const showNoFeatureAccessModal = (showModal: ShowModal) => {
    showModal('info', { ...noFeatureAccessModalProps });
};

export const noDemoAccessModalProps = {
    title: 'Demo account',
    description: 'This feature is not allowed in demo mode',
    question: '',
};

export const showNoDemoAccessModal = (showModal: ShowModal) => {
    showModal('info', { ...noDemoAccessModalProps });
};

export const trialLicenseModalProps = {
    title: 'Free trial license',
    description: 'A free trial license cannot be modified. Please purchase a license to change your plan, users or sites.',
    question: '',
};

export const showTrialLicenseModal = (showModal: ShowModal) => {
    showModal('info', { ...trialLicenseModalProps });
};

export const isTrialLicense = (license: any): boolean =>
    [true, 1, '1', 'true'].includes(license?.is_trial ?? license?.isTrial);
